import { useAuth } from "components/Auth";
import { useAppSelector } from "redux/hooks";
import { ValidAuth } from "redux/reducers/auth/isAuth";
import ErrorBox from "components/blocks/error/ErrorBox";

export default function OrgNotfound(): JSX.Element {
  const { isLogout, isAuthenticated }: ValidAuth = useAppSelector(
    (state) => state.isAuth
  );

  const { onForwardLogin } = useAuth();

  const onReturn = () => {
    if (!isLogout && !isAuthenticated) {
      onForwardLogin();
      return;
    }
    window.location.href = "/login";
  };
  return (
    <>
      <ErrorBox
        title="Error 403"
        subtitle="Organization not found."
        onReturn={onReturn}
        message="Sorry, we couldn't find organization."
        buttonLabel="Return to myDW"
      >
        <p>
          Organization you are looking for may have been deleted, or you do not
          have access permissions.
          <br />
          <br />
          Click the button below to return to a working page on the site and
          resuming using myDW.
        </p>
      </ErrorBox>
    </>
  );
}
